<template>
  <ValidationProvider
    :rules="rules"
    :name="fieldId"
    class="form-group"
    tag="div"
  >
    <template slot-scope="{ errors }">
      <label class="control-label col-sm-2" :for="fieldId">
        {{ name }}
        <span class="text-danger" v-if="required">*</span>
      </label>
      <div class="col-sm-9">
        <textarea
          :id="fieldId"
          :name="fieldId"
          v-model="val"
          :title="tooltip"
          class="form-control"
          :required="required"
          :disabled="!enabled"
          :pattern="computedPattern"
        />
        <small class="text-muted input-description">{{ description }}</small>
        <div>
          <small
            v-for="error in errors"
            :key="error"
            class="text-danger input-error"
            >{{ error }}</small
          >
        </div>
      </div>
    </template>
  </ValidationProvider>
</template>

<script>
import Vue from "vue";
import { ValidationProvider } from "vee-validate";

export default Vue.extend({
  name: "text-area-field",
  components: {
    ValidationProvider
  },
  data() {
    return {};
  },
  props: {
    fieldId: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    tooltip: String,
    description: String,
    required: {
      type: Boolean,
      default: false
    },
    enabled: {
      type: Boolean,
      default: true
    },
    value: String,
    pattern: {
      type: String,
      required: false
    }
  },
  computed: {
    rules() {
      const rules = {};
      if (this.required) {
        rules["required"] = true;
      }
      if (this.computedPattern) {
        rules["regex"] = this.computedPattern;
      }
      return rules;
    },
    computedPattern() {
      if (!this.pattern) {
        return null;
      }
      return this.pattern;
    },
    val: {
      // getter
      get: function() {
        return this.value;
      },
      // setter
      set: function(newVal) {
        this.$emit("input", newVal);
      }
    }
  }
});
</script>

<style scoped></style>
